import { createContext, useContext, useEffect, useState } from 'react';

const Context = createContext<[boolean, () => void]>([false, () => void {}]);

const ThemeContext = (props: any) => {

    const [darkTheme, setDarkTheme] = useState(localStorage.getItem("theme") === "dark");

    useEffect(() => {
        const savedTheme = localStorage.getItem("theme");

        if(savedTheme != "light" && window.matchMedia("(prefers-color-scheme: dark)").matches){
            toggleTheme();
        }

    }, [])

    function toggleTheme(){
        if(darkTheme){
            localStorage.setItem("theme", "light");
        }else{
            localStorage.setItem("theme", "dark");
        }
        
        setDarkTheme(!darkTheme);
    }

    return (
        <Context.Provider value={[
            darkTheme,
            toggleTheme
        ]}>
            {props.children}
        </Context.Provider>
    )
}

export default ThemeContext

export function useTheme(): [boolean, () => void] {
    return useContext(Context);
}
